<template>
  <a-card :bordered="false">
    <a-row type="flex" justify="start" align="top" :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:24}">
        <div class="containerhtmlNDA">
          <vue-html2pdf
            :show-layout="false"
            :float-layout="false"
            :enable-download="false"
            :preview-modal="false"
            filename="hee hee"
            :manual-pagination="false"
            ref="html2Pdf"
            :paginate-elements-by-height="500"
            :html-to-pdf-options="htmlToPdfOptions"
          >
            <section slot="pdf-content">
                  <!-- PDF Content Here -->
                  <div v-html="htmlcontent" class="content_nda"></div>
              </section>
          </vue-html2pdf>
        </div>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:24}">
        <div style="height: 50px;display: flex;"><div style="align-self: end;">Please sign your signature on area below.</div></div>
        <div style="background:rgb(239,239,239)">
          <vueSignature
            ref="signature"
            :sigOption="option"
            :w="'auto'"
            :h="signatureHeightArea"
            :disabled="false"
            class="dsignature"
          ></vueSignature>
          <a-button type="danger" size="small" @click="canvasClear" class="dsignature-btn">Clear Area</a-button>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import VueHtml2pdf from 'vue-html2pdf'
import vueSignature from "vue-signature"
import htmlcontentSource from '@/assets/NonDisclosureAggrement_source.htm'
import moment from "moment";

export default {
  name: "formNDA",
  props: ['collectedData',"datamaster"],
  components: {
    vueSignature,
    VueHtml2pdf
  },
  data() {
    return {
      htmlcontentSource,
      htmlcontent: null,
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "#efefef00",
      },
      signatureHeightArea: '450px',
      htmlToPdfOptions: {
        margin: [2,2,2,2],
    
        filename: `nda.pdf`,
    
        image: {
            type: 'png', 
            quality: 1
        },
    
        enableLinks: false,
    
        html2canvas: {
            scale: 1,
            useCORS: false,
            logging: true,
            dpi: 192,
            letterRendering: true
        },
    
        jsPDF: {
            unit: 'cm',
            format: 'a4',
            orientation: 'portrait'
        }
      }
    };
  },
  computed: {
    ...mapGetters(["getMaster", "getBank", "getDefaultDateFormat"]),
  },
  activated(){
    this.htmlcontent = this.htmlcontentSource
    .replaceAll('#TYPE_IDENTITY#', _.filter(this.datamaster.jenis_identitas, (item)=>item.value==this.collectedData.profile.jenis_identitas)[0].text)
    .replaceAll('#NM_IDENTITY#', this.collectedData.profile.no_identitas)
    .replaceAll('#NM_LNGKP#', this.collectedData.profile.nama)
    .replaceAll('#NM_SKLH#', this.getNamaSekolah(this.collectedData.document.sekolah))
    .replaceAll('#TUJUAN#', this.collectedData.kegiatan.jenis_kegiatan)
    .replaceAll('#KONTAK#', "+"+this.collectedData.profile.noTelp_code+this.collectedData.profile.telpon)
    .replaceAll('#WAKTU#', this.getWaktu(this.collectedData.kegiatan.tglmasuk,this.collectedData.kegiatan.tglselesai))
    .replaceAll('#TGL#', this.moment(this.collectedData.kegiatan.tglmasuk).format('DD-MM-YYYY')+" s.d "+this.moment(this.collectedData.kegiatan.tglselesai).format('DD-MM-YYYY'))
  },
  methods: {
    moment,
    async handleRef() {
      if(this.$refs.signature.isEmpty()){
        this.$notification.warning({
          title: `Warning!`,
          message:
            "Please sign your signature first!",
        });
      }else{
        let a = this.$refs.signature.save()
        let values = {
          signature : null
        }
        await fetch(a).then(async r => {
          let ndaSignature = await r.blob()
          values.signature =  ndaSignature;
        })
        Event.$emit("createKaryawan", values);
      }
    },
    canvasClear(){
      this.$refs.signature.clear();
    },
    getNamaSekolah(value){
      let res = _.filter(this.datamaster.sekolah, filter => filter.id_sekolah==value)
      return res.length>0 ? res[0].nama_sekolah : ""
    },
    getWaktu(start,end){
      let years = this.moment(end).diff(this.moment(start), 'years');
      let month = this.moment(end).diff(this.moment(start), 'months');
      let day = this.moment(end).diff(this.moment(start), 'days');
      let hour = this.moment(end).diff(this.moment(start), 'hours');
      console.log(years, month, day, hour)
      return years>0 ? years.toString()+ " Tahun" : ( month>0 ? month.toString()+" Bulan" : (day>0 ? day.toString()+" Hari": hour.toString()+" Jam"))
    }
  }
}

</script>
<style lang="less" scoped>
.containerhtmlNDA{
  height: 500px;
  overflow: auto;
  background-color: #c1c1c1;
  justify-items: center;
}
.content_nda{
  margin:25px;
  padding: 25px;
  background-color: #ffffff;
}
.dsignature-btn{
  z-index: 1000;
}
</style>